import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import M from 'materialize-css/dist/js/materialize';
import PackListService from '../../../services/PackListService';
import { translate, makeEnum, isNullOrEmpty, gerarCSV } from '../../../utils/util';
import { ENUMS, PERMISSIONS } from '../../../utils/constants'
import { Breadcrumbs, Button, Input, Select, ListPagination } from '../../../components/UI/ComponentsUI';
import { onValueChange, validateInputsRequired } from '../../../utils/handleChangeHooks';
import ListItemOrder from './ListOrder'
import ConfirmModalPackList from './ConfirmModalPackList'
import { checkPermission } from '../../../services/auth'
import * as packListAction from '../../../actions/packListAction';

const PackingList = (props) => {
    const [currentPage, setCurrentPage] = useState(0);
    const [instanceM, setInstanceM] = useState();
    const [arrayDrop, setArrayDrop] = useState([]);
    const [data, setData] = useState([]);
    const [openModalConfirm, setOpenModalConfirm] = useState(false);
    const [packList, setPackList] = useState();
    const [filter, setFilter] = useState(
        {
            orderCode: props.filter?.orderCode || "",
            supplierCode: props.filter?.supplierCode || "",
            partNumber: props.filter?.partNumber || "",
            statusPackList: props.filter?.statusPackList || []
        });


    useEffect(() => {
        if (props.orders?.items?.length > 0) {
            if (data.length > 0 && currentPage === 0) {
                setData([...props.orders.items]);
            } else {
                setData((prevState) => ([...prevState, ...props.orders.items]));
            }
        } else {
            setData([]);
        }

        // eslint-disable-next-line
    }, [props?.orders?.items]);

    useEffect(() => {
        if (currentPage > 0) {
            onFilter();
        }
        // eslint-disable-next-line
    }, [currentPage]);

    useEffect(() => {
        const instance = M.Collapsible.init(document.querySelectorAll('.collapsible'), {
            accordion: false
        });
        setInstanceM(instance);
        var drop = makeEnum(ENUMS.ePackListStatus).map((i) => {
            return { id: i.value, text: translate(i.text) };
        });

        setArrayDrop(drop);

        if (!checkPermission(PERMISSIONS.Expedition.PackList.Manage)) {
            if (checkPermission(PERMISSIONS.Expedition.PackList.Finance)) {
                filter.statusPackList.push(Number(ENUMS.ePackListStatus.PendingFinance.value));
                setFilter({ ...filter });
                props.setFilterPackList(filter);
            }

            if (checkPermission(PERMISSIONS.Expedition.PackList.Patrimonial)) {
                filter.statusPackList.push(Number(ENUMS.ePackListStatus.PropertyPending.value));
                setFilter({ ...filter });
                props.setFilterPackList(filter);
            }
        }
        onFilter();
        // eslint-disable-next-line
    }, []);

    const onFilter = (click) => {
        let currentPageList = currentPage;
        if (validateInputsRequired("formsReport")) {
            if (click) {
                currentPageList = 0;
                setCurrentPage(0);
            }
            props.getOrders(filter, {
                PageSize: 20,
                PageIndex: currentPageList
            }, () => { instanceM[1].close(); });
        }
    }

    const onChange = (event) => {
        onValueChange(event, filter, setFilter);
        props.setFilterPackList(filter);
    };

    const addStatusFilter = (item) => {
        const itemSelect = item.currentTarget.options[item.currentTarget.selectedIndex];
        if (!isNullOrEmpty(itemSelect?.value)) {
            const id = Number(itemSelect.value);
            if (!filter.statusPackList.find((f) => Number(f.id) === Number(id))) {
                filter.statusPackList.push(id);
                setFilter({ ...filter });
                props.setFilterPackList(filter);
            }
        }
    };

    const removedStatusFilter = (id) => {
        const items = filter.statusPackList.filter((item) => Number(item) !== Number(id));
        if (items) {
            filter.statusPackList = items;
            setFilter({ ...filter });
            props.setFilterPackList(filter);
        }
    }

    const downloadReport = () => {
        props.report(filter, (response) => {
            gerarCSV("Romaneio", response)
        });
    }

    const createPackList = (justification) => {
        const send = {
            orderId: packList.orderId,
            justificationId: justification.justificationId,
            observation: justification.justificationText,
        };

        props.createPackList(send, () => {
            onFilter(true);
        });
    }

    return (
        <div>
            <Breadcrumbs id="transmissionTitle" title={{ icon: "mdi mdi-clipboard-list-outline", label: 'Romaneio' }} />
            <div className="container-fluid" style={{ marginTop: '20px' }}>
                <div className="container" style={{ marginTop: '0px' }}>
                    <ul id='collapsible' className="collapsible">
                        <li className='active'>
                            <div className="collapsible-header">
                              {translate('line-picking:linepicking.filter')}
                            </div>
                            <div className="collapsible-body" style={{ padding: '10px' }}>
                                <div id="formsReport" className="row">
                                    <div className="input-field no-padding col s5">
                                        <Input
                                            id="orderCode"
                                            name='orderCode'
                                            placeholder={translate('line-picking:transmission.call')}
                                            type="text"
                                            onChange={onChange}
                                            defaultValue={props.filter?.orderCode}
                                        />
                                    </div>

                                    <div className="input-field no-padding col s5">
                                        <Input
                                            id="partNumber"
                                            name='partNumber'
                                            placeholder={translate('line-picking:linepicking.partnumber')}
                                            type="text"
                                            onChange={onChange}
                                            defaultValue={props.filter?.partNumber}
                                        />
                                    </div>
                                    <div className="input-field no-padding col s5">
                                        <Input
                                            id="supplierCode"
                                            name='supplierCode'
                                            placeholder={translate('expedition:picking.supplier')}
                                            type="text"
                                            onChange={onChange}
                                            defaultValue={props.filter?.supplierCode}
                                        />
                                    </div>

                                    {
                                        checkPermission(PERMISSIONS.Expedition.PackList.Manage)
                                            ?
                                            <div className="input-field no-padding col s12">
                                                <Select
                                                    id="statusPackList"
                                                    name="statusPackList"
                                                    display="description"
                                                    change={addStatusFilter}
                                                    placeHolder={`Status - ${translate('general:choose-one-option')}`}
                                                    data={arrayDrop}
                                                />
                                            </div> : null

                                    }

                                    {
                                        checkPermission(PERMISSIONS.Expedition.PackList.Manage) ?
                                            filter.statusPackList.map((item, index) =>
                                                <div key={index} className="no-padding col s12">
                                                    <div key={`${index}-div`} className="list sixth-text-color">
                                                        <i onClick={() => removedStatusFilter(item)} className={`mdi mdi-21px mdi-alpha-x-circle-outline`} />
                                                        {arrayDrop && arrayDrop.find((f) => f.id === item)?.text}
                                                    </div>
                                                </div>) : null
                                    }
                                </div>
                                <div className="row" style={{ paddingTop: '5px' }}>
                                    <Button onClick={() => onFilter(true)} full="true" text={translate('delivery:general.search')} />
                                </div>
                            </div>
                        </li>
                    </ul>
                    {
                        data.length > 0 && navigator.userAgent !== 'logisticspwa' &&
                        <div className="row" style={{ paddingTop: '5px' }}>
                            <Button onClick={downloadReport} full="true" text= {translate('line-picking:linepicking.generate-report')} />
                        </div>
                    }
                </div>
                <div id="listtransmissions">
                    <ListPagination
                        page={props.orders?.totalPages}
                        current={{ currentPage, setCurrentPage }}
                        data={
                            data.map((item) => {
                                return (
                                    <ListItemOrder
                                        report
                                        key={`o-${item.orderId}-${item.status}`}
                                        data={item}
                                        createPackList={(packList) => {
                                            setOpenModalConfirm(true);
                                            setPackList(packList);
                                        }}
                                        approve={(packList) => props.approve(packList, () => {
                                            onFilter(true)
                                        })}
                                        reprove={(packList) => props.reprove(packList, () => {
                                            onFilter(true)
                                        })}
                                    />
                                );
                            })
                        }
                    />
                </div>
            </div>
            <ConfirmModalPackList
                open={openModalConfirm}
                id="ConfirmModalPackList"
                content= {translate('line-picking:linepicking.request-romaneio')}
                dismissible={false}
                justifications={props.justifications}
                onCancel={() => setOpenModalConfirm(false)}
                onClose={() => setOpenModalConfirm(false)}
                onConfirm={(evt) => {
                    createPackList(evt);
                }}
            />

        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        justifications: state.justificationReducer.justifications,
        orders: state.packListReducer.orders,
        filter: state.packListReducer.filter
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getOrders: (filter, pagination, callback) => {
            dispatch(PackListService.get(filter, pagination, callback));
        },
        createPackList: (packList, callback) => {
            dispatch(PackListService.createPackList(packList, callback));
        },
        approve: (packList, callback) => {
            dispatch(PackListService.approve(packList, callback));
        },
        reprove: (packList, callback) => {
            dispatch(PackListService.reprove(packList, callback));
        },
        report: (filter, callback) => {
            dispatch(PackListService.report(filter, callback));
        },
        setFilterPackList: (filter) => {
            dispatch(packListAction.setFilter(filter));
        },
        resetFilter: () => {
            dispatch(packListAction.resetFilter());
        }
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(PackingList)));
